module.exports = __webpack_public_path__ + "img/waving-hand-joypixels.30169e4a.gif";